// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__T3KbD","productName":"Table_productName__2dWID"};